<template>
  <div class="question-view hotspot" >
    <div class="quest">
      <div class="title">
        <vue-mathjax :formula="form.title" @onRenderComplete="mathjaxRes" :safe="false"/>
      </div>
    </div>
    
    <div class="quest-img">
      <img :src="form.img_url" alt="">
    </div>
  </div>
</template>

<script>
import HotspotDrag from './hotspotDrag/hotspotDrag'

export default {
  props: ['form'],
  data() {
    let letter = new Array(26).fill().map((its, idx) => its = String.fromCharCode(65 + idx))

    return {
      letter,
      image: '',
      topic: '',
      hotspotData: [],

      drag: null
    }
  },
  methods: {
    mathjaxRes() {
      // console.log('热点题')
      this.$emit('onRenderComplete')
    }
  },
  created() {
    // transfer.$on('hotspot', ({image, topic, hotspotData}) => {
    //   this.image = image
    //   this.topic = topic
    //   this.hotspotData = hotspotData

    //   this.drag && this.drag.echoBlock(hotspotData, this)
    // })

  }, 
  mounted() {
    this.drag = new HotspotDrag({
      plate: '.quest-img',
      useType: 'view',
    })
    
    let content = JSON.parse(this.form.content)
    // console.log(content)
    this.drag.echoBlock(content.hotspotData, this)
  }
}
</script>

<style scoped lang="scss">
.question-view {
  width: 100%;
  height: 100%;
  padding: 20px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px;
  .quest {
    width: calc(55% - 10px);
    height: 100%;

    .title {
      font-size: 15px;
      color: #333;
    }

  }
  .quest-img {
    width: 493px;
    height: 300px;
    background-color: #fff;
    position: relative;
    background-size: 100% 100%;
    .img-region {
      position: relative;
      display: flex;
      overflow: hidden;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        position: absolute;
        background-color: #fff;
        color: #333;
      }

      &:after, &:before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: -50%;
        margin: auto;
        height: 1px;
        width: 200%;
        background-color: #fff;
        transform: rotateZ(45deg);
      }

      &:before {
        transform: rotateZ(-45deg);
      }
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>

<style lang="scss">
.click-style {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  display: none;

  &:before {
    content: '';
    position: absolute;
    top: -5px;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 10px;
    height: 20px;
    border: 3px solid #007516;
    border-top: none;
    border-left: none;
    transform: rotateZ(50deg);
  }
}

.block-style-circle {
  position: absolute;
  top: 80px;
  left: 80px;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
  background-color: transparent;
  background-size: 100% 100%;

  
  &:before {
    content: '';
    border-radius: 50%;
  }
}

.hotspot {
  .block-style {
    width: 80px;
    height: 80px;
    position: absolute;
    top: 80px;
    left: 80px;
    cursor: pointer;
    z-index: 1;
    background-size: 100% 100%;
    
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 1px dashed #333;
    }

    .success, .error {
      position: absolute;
      bottom: -5px;
      right: -5px;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: #007416;
      display: none;
    }

    .success {
      &:before {
        content: '';
        color: #fff;
        position: absolute;
        top: -5px;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 10px;
        height: 6px;
        border: 2px solid #fff;
        border-top: none;
        border-right: none;
        transform: rotateZ(-50deg);
        transform-origin: center center;
      }
    }

    .error {
      background-color: #d60215;

      &:before, &:after {
        content: '';
        width: 10px;
        height: 2px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        transform: rotateZ(-45deg);
        transform-origin: center center;
        background-color: #fff;
      }

      &:after {
        transform: rotateZ(45deg);
      }
    }
  }
}
</style>